<template>
    <div>
        <modal-dialog title="友情提醒" ref="dialog">
            <div class="content2">
                <div style="text-align: center; padding-top: 36px;">
                    <auto-icon src="/icon/all_popup_icon_correct" v-show="type === 'success'"></auto-icon>
                    <auto-icon src="/icon/all_popup_icon_risk" v-show="type === 'error'"></auto-icon>
                    <auto-icon src="/icon/all_popup_icon_waiting" v-show="type === 'clock'"></auto-icon>
                </div>
                <div class="flexer"></div>
                <div class="text"><span style="display: inline-block; max-width: 420px">{{ content }}</span></div>
                <div class="flexer"></div>
                <div class="bottom">
                    {{ timeLeft }}s后自动关闭
                </div>
            </div>
        </modal-dialog>
    </div>
</template>
<style scoped>
    .content2 {
        display: flex;
        height: 100%;
        flex-direction: column;
    }

    .flexer {
        flex: 1;
    }

    .text {
        font-family: PingFangSC-Regular;
        font-size: 20px;
        color: #232C3D;
        line-height: 42px;
        text-align: center;
    }

    .bottom {
        text-align: center;
        height: 55px;
        font-family: PingFangSC-Regular;
        font-size: 16px;
        color: #367EFF;
    }
</style>
<script>
    import ModalDialog from './ModalDialog.vue'
    import AutoIcon from './AutoIcon.vue'

    //type: 'success', 'clock', 'error'
    export default {
        components: { ModalDialog, AutoIcon },
        props: ['content', 'type'],
        data() {
            return {
                timeLeft: 3
            }
        },
        methods: {
            open() {
                this.$refs.dialog.open();
                this.timeLeft = 3;
                let handler = setInterval(() => {
                    this.timeLeft -= 1;
                    if (this.timeLeft === 0) {
                        this.$refs.dialog.close();
                        this.$emit('close', this.type);
                        clearInterval(handler);
                    }
                }, 1000)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/AutoCloseDialog.vue